function CloseIcon({ size = 20, stroke = "currentColor", strokeWidth = 2.16 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M1.4 1.4L12.6 12.6M12.6 1.4L1.4 12.6"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  );
}

export default CloseIcon;
